var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,43.3l-2.1-2.1l13.2-13.5l6.9,7L42.4,24l2.1,2.1L31.8,39l-6.9-7L13.8,43.3L13.8,43.3z M6.4,41.7c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.5-0.9-1.3-0.9-2.1v-31c0-0.8,0.3-1.6,0.9-2.1C4.9,5,5.6,4.7,6.4,4.7h29.5c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1v9.9H6.4L6.4,41.7L6.4,41.7z M6.4,14.6h29.5V7.7H6.4L6.4,14.6L6.4,14.6z M6.4,14.6L6.4,14.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.7340cc7bf35f4fe7fc39397628d622e7.svg";
export { ForwardRef as ReactComponent };